export const mixMatch = ({data = [], productId = null}) => {
    return {
        colourOptions: data,
        productId: productId,
        selectedColours: {1: null, 2: null, 3: null, 4: null},
        showDropdown: {1: false, 2: false, 3: false, 4: false},

        allColoursSelected() {
            for (let i = 1; i <= 4; i++) {
                if (!this.selectedColours[i]?.colour) {
                    return false;
                }
            }

            return true;
        },

        init() {
            if (!window.mixMatchComponents) {
                window.mixMatchComponents = {};
            }
            window.mixMatchComponents[this.productId] = this;
        },
    };
};
